import React, { Component } from 'react';
import Modal from 'react-modal';
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils';
import { withRouter } from 'react-router-dom';
import NachUpdateModalUI from './NachUpdateModalUI';
class NachUpdateModalSF extends Component {
	constructor(props) {
		super(props);
		this.state = {
			successMsg: null,
			errorList: null,
			submitted: false,
			nach: '',
			nachError: null,
		};
	}
	render() {
        let booleanList = [
            { key: 'true', value: 'Yes' },
            { key: 'false', value: 'No' },
          ]
		return (
			<NachUpdateModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				updateMode={this.props.updateMode}
				submitted={this.state.submitted}
				onSubmit={this.onSubmit}
				onCancelClick={this.props.onCancelCreate}
				nach={this.state.nach}
                booleanList={booleanList}
                nachError={this.state.nachError}
                setNachError={(error) => this.setState({ nachError: error })}
                onNachChange={(event) => this.setState({ nach: event.target.value })}
			/>
		);
	}
	componentDidMount() {
		Modal.setAppElement('body');
	}
	onCancelCreate = () => {
		this.setState({
			submitted: false,
			errorList: null,
		});
		this.props.onCancelCreate();
	}
	onSubmit = () => {
        if (this.state.submitted) return
    
        this.setState({
          successMsg: null,
          errorList: [],
          submitted: true
        })
    
        RestApiUtils.put(this.props.context,
          `/api/su/accounts/${this.props.account.accountId}/updateNach`,
          this.onSubmitCallback,
          {
            nachTransfer: this.state.nach
          }
        )
      }


	onSubmitCallback = (response) => {
		let errorList = [];
		if (response.errorList) {
			errorList = response.errorList.map((error) => error.message);
		}
		this.setState({
			successMsg: response.success || null,
			errorList: errorList,
			submitted: false,
		});
		if (errorList.length === 0) {
			setTimeout(() => {
				this.setState({ successMsg: null });
				this.props.onCancelCreate();
				this.props.onRefreshClick();
			}, 1000);
		}
	}
	setErrorList = (errorList) => {
		this.setState({ errorList: errorList });
	}
}
export default withRouter(NachUpdateModalSF);